import {ComponentChild, h} from 'preact'
import Panel from '../../control-components/panel'

const CommunityFooter = ({ switcher }: {switcher: ComponentChild}) => {
  return (
    <Panel
      customClass='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          Footer
          { switcher }
        </div>
      } />
  )
}

export default CommunityFooter
